export default __webpack_public_path__ + "static/media/0008.d770b60f.png";